<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item> 报号计划 </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-box toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="item-label">装货地址</span>
        <el-input v-model.trim="filter.sourceAddressName" placeholder="请输入装货地址" style="width: 300px" clearable>
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="item-label">卸货地址</span>
        <el-input v-model.trim="filter.targetAddressName" placeholder="请输入卸货地址" style="width: 300px" clearable>
        </el-input>
      </div>

      <div class="toolbar-item" id="auto-2">
        <el-button type="primary" size="small" @click="search"> 筛选</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 报号计划列表 </span>
      </div>
      <div class="fr">
        <el-button type="primary" size="small" id="auto-3" @click="differentJump(1)"> 创建报号计划</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-4">
      <el-table :data="tableData.data" border>
        <el-table-column prop="sourceAddressName" label="装货地名称" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="targetAddressName" label="卸货地名称" min-width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="unitPrice" label="运费单价（元/吨）" width="130"> </el-table-column>
        <el-table-column prop="bookCloseTime" label="报号截止日期" width="140">
          <template v-slot="scope">
            <span v-if="scope.row.bookCloseTime > 0">{{ scope.row.bookCloseTime | stamp2TextDateFull(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="loadTime" label="装车日期" width="140">
          <template v-slot="scope">
            <span>{{ scope.row.loadTime | stamp2TextDateFull(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="loadCloseTime" label="装车截止日期" width="140">
          <template v-slot="scope">
            <span>{{ scope.row.loadCloseTime | stamp2TextDateFull(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="needCarNum" label="要车数量"> </el-table-column>
        <el-table-column prop="remainNum" label="剩余数量"> </el-table-column>
        <el-table-column prop="driverNum" label="当前报号数量" width="100"> </el-table-column>

        <el-table-column label="操作" width="250px">
          <template v-slot="scope">
            <el-button type="text" @click="differentJump(2, scope.row)">详情</el-button>
            <el-button type="text" @click="differentJump(3, scope.row)">添加计划</el-button>
            <el-button type="text" @click="differentJump(4, scope.row)">查看司机</el-button>
            <el-button type="text" v-if="scope.row.unitPriceConfirm === '0'" @click="changePrice(scope.row)"
              >调价</el-button
            >
            <el-button type="text" @click="changePriceLog(scope.row)">调价历史</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- 调价 -->
    <el-dialog title="调价" :visible="isSure" :show-close="false" width="400px">
      <el-input v-model.trim="newPrice" placeholder="请输入单价" width="200px"> </el-input>
      <div class="mt-10 ml-10">
        <el-checkbox v-model="isConfirmPrice">确认运费单价</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="!newPrice && !isConfirmPrice" @click="onConfirm">保存</el-button>
        <el-button @click="isSure = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 调价历史 -->
    <el-dialog title="调价历史" :visible.sync="dialogVisible" width="30%">
      <el-table :data="logData" border>
        <el-table-column label="运费单价（元/吨）" prop="unitPrice"></el-table-column>
        <el-table-column label="报号数量" prop="carNum">
          <template v-slot="scope">
            <span class="mr-10"> {{ scope.row.carNum }} </span>
            <template v-if="scope.row.addNum > 0 || scope.row.subNum > 0">
              ( <span class="blueFont" v-if="scope.row.addNum > 0"> +{{ scope.row.addNum }} </span>

              <span class="redFont" v-if="scope.row.subNum > 0"> -{{ scope.row.subNum }} </span>)</template
            >
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="createUserName"></el-table-column>

        <el-table-column label="操作时间" prop="createTime">
          <template v-slot="scope">
            <span>{{ scope.row.createTime | stamp2TextDateFull(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */

import axios from '@/api/axiosNew';
import api from '@/api/stock.new.api.js';
import { isNumber, isRangeNumber } from '@fe/validator';
import { WUYI } from '@/api/common';
export default {
  data() {
    return {
      pageSize: 20,
      tableData: {
        data: [],
        total: 0
      },
      logData: [],
      dialogVisible: false,
      isSure: false,
      isConfirmPrice: false,
      currentPage: 1,
      newPrice: '',
      id: '',
      cache: {},
      filter: {
        companyId: WUYI.currentData.company.companycode,
        sourceAddressName: '',
        targetAddressName: ''
      }
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.cache = { ...this.filter };
      this.axiosRequest();
    },
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    axiosRequest() {
      axios
        .post(api.queryBookScheduleList, {
          ...this.cache,
          callSource: 1,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableData.data = res.data.data || [];
          this.tableData.total = res.data.total;
        });
    },
    changePrice(row) {
      this.id = row.id;
      this.isSure = true;
      this.isConfirmPrice = false;
      this.newPrice = '';
    },
    checkNumberVali(val) {
      if (isNumber(val) && isRangeNumber(val, 0, 100000000, true, false)) {
        return true;
      }
      return false;
    },
    onConfirm() {
      // var reg = /^([1-9]\d{0,7}|0)(\.\d{1,2})?$/; // 0 - 99999999.99
      if (!this.isConfirmPrice) {
        if (!this.checkNumberVali(this.newPrice)) {
          this.$message.error('仅支持八位数字并且保留两位小数');
          return;
        }
      }
      axios
        .post(api.adjustBookSchedulePrice, {
          id: this.id,
          isConfirmPrice: this.isConfirmPrice,
          newPrice: this.newPrice ? this.newPrice : null,
          callSource: 1
        })
        .then(res => {
          this.$message.success('调整成功');
          this.axiosRequest();
          this.isSure = false;
        });
    },
    changePriceLog(row) {
      this.dialogVisible = true;
      axios.post(api.schedulePriceHis, { id: row.id, callSource: 1 }).then(res => {
        this.logData = res.data;
      });
    },
    differentJump(type, row) {
      switch (type) {
        case 1:
          // 创建报号计划
          this.$router.push('/bookScheduleChange/create');
          break;
        case 2:
          // 报号详情
          window.open(`./stock.html#/bookScheduleDtl/${row.id}`);
          break;
        case 3:
          // 添加报号计划
          window.open(`./stock.html#/bookScheduleChange/add/${row.id}`);
          break;
        case 4:
          // 司机列表
          window.open(`./stock.html#/bookDriver/${row.id}`);
          break;
      }
    }
  }
};
</script>
<style>
.blueFont {
  color: green;
  margin-right: 5px;
}
.redFont {
  color: red;
}
</style>
